import React from "react";
import { NavLink } from "react-router-dom";

function Footer() {
  return (
    <>
      <footer className="footer widget-footer bg-base-dark clearfix">
        <div className="second-footer">
          <div className="container">
            <div className="row g-0">
              <div className="col-xl-4 col-lg-6 col-md-6">
                <div className="footer-widget-box first-child">
                  <h3 className="widget-title-h3">About Us:</h3>
                  <div className="prt-iconbox">
                    <div>
                      Moironix Soft Solutions delivers cutting-edge technology
                      solutions for business success. We specialize in website
                      development, mobile apps, and custom software, driving
                      digital transformation with innovation, quality, and
                      client satisfaction
                    </div>
                  </div>
                  <h3 className="widget-title-h3 pt-4">Information</h3>
                  <div className="footer-menu-links">
                    <ul className="footer-menu-list">
                      <li className="footer-menu-item">
                        <NavLink
                          to="/contact"
                          className="footer-menu-item-link"
                        >
                          Contact
                        </NavLink>
                      </li>
                      <li className="footer-menu-item">
                        <NavLink
                          to="/privacy-policy"
                          className="footer-menu-item-link"
                        >
                          Privacy Policy
                        </NavLink>
                      </li>
                      <li className="footer-menu-item">
                        <NavLink
                          to="/terms-and-conditions"
                          className="footer-menu-item-link"
                        >
                          Terms & Conditions
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                  <div className="footer-social-links-wrapper">
                    <ul className="footer-social-icons">
                      <li className="footer-social-icons-item">
                        <a
                          href="https://www.facebook.com/moironixsoftsolutions"
                          target="_blank"
                          className="footer-social-icons-link"
                        >
                          Facebook
                        </a>
                      </li>
                      <li className="footer-social-icons-item">
                        <a
                          href="https://www.linkedin.com/company/moironix"
                          target="_blank"
                          className="footer-social-icons-link"
                        >
                          Linkedin
                        </a>
                      </li>
                      <li className="footer-social-icons-item">
                        <a
                          href="https://www.instagram.com/moironixsoft"
                          target="_blank"
                          className="footer-social-icons-link"
                        >
                          Instagram
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6">
                <div className="footer-widget-box ">
                  <h3 className="widget-title-h3">Quick Links</h3>
                  <div className="footer-menu-links">
                    <ul className="footer-menu-list">
                      <li className="footer-menu-item">
                        <NavLink to="/about" className="footer-menu-item-link">
                          About
                        </NavLink>
                      </li>
                      <li className="footer-menu-item">
                        <NavLink to="/blog" className="footer-menu-item-link">
                          Blog
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                  <h3 className="widget-title-h3">Services</h3>
                  <div className="footer-menu-links">
                    <ul className="footer-menu-list">
                      <li className="footer-menu-item">
                        <NavLink
                          to="/application-development"
                          className="footer-menu-item-link"
                        >
                          Application Development
                        </NavLink>
                      </li>
                      <li className="footer-menu-item">
                        <NavLink
                          to="/website-design-development"
                          className="footer-menu-item-link"
                        >
                          Web Design & Development
                        </NavLink>
                      </li>
                      <li className="footer-menu-item">
                        <NavLink
                          to="/mobile-application-development"
                          className="footer-menu-item-link"
                        >
                          Mobile Application Development
                        </NavLink>
                      </li>

                      <li className="footer-menu-item">
                        <NavLink
                          to="/digital-marketing"
                          className="footer-menu-item-link"
                        >
                          Digital Marketing
                        </NavLink>
                      </li>
                      <li className="footer-menu-item">
                        <NavLink
                          to="/graphic-design"
                          className="footer-menu-item-link"
                        >
                          Graphic Designing
                        </NavLink>
                      </li>
                      <li className="footer-menu-item">
                        <NavLink
                          to="/software-maintenance"
                          className="footer-menu-item-link"
                        >
                          Software Maintenance & Support
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-lg-6 col-md-6">
                <div className="footer-widget-box last-child">
                  <div className="widget_nav_menu">
                    <div className="textwidget-widget-text">
                      <div className="prt-numbertext">
                        <p className="prt-numbertext-p">Our phone number</p>
                        <h3 className="prt-numbertext-h3">
                          <a
                            href="tel:++918328473790"
                            className="prt-numbertext-link"
                          >
                            040-45244795, <br></br>
                            +91 8328 473 790
                          </a>
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div className="prt-horizontal_sep mb-45 mt-15 res-991-mt-10 res-991-mb-25" />
                  <div className="widget_nav_menu">
                    <div className="textwidget-widget-text">
                      <div className="prt-numbertext">
                        <p className="prt-numbertext-p">Our email address</p>
                        <h3 className="prt-numbertext-h3">
                          <a
                            href="mailto:contact@company.com"
                            className="prt-numbertext-link"
                          >
                            info@moironix.com,
                          </a>
                        </h3>
                        <h3 className="prt-numbertext-h3">
                          <a
                            href="mailto:moironix@gmail.com"
                            className="prt-numbertext-link"
                          >
                            moironix@gmail.com
                          </a>
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div className="prt-horizontal_sep mb-45 mt-15 res-991-mt-10 res-991-mb-25" />
                  <div className="widget_nav_menu">
                    <div className="textwidget-widget-text">
                      <div className="prt-numbertext">
                        <p className="prt-numbertext-p">Address</p>
                        <h3 className="prt-numbertext-h3">
                          <a
                            href="mailto:contact@company.com"
                            className="prt-numbertext-link"
                          >
                            19/2RT, 1st Floor, Officers Colony, Punjagutta,
                            Hyderabad 500082, India
                          </a>
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-12 col-lg-12 col-md-12">
                <div className="prt-horizontal_sep mb-40 mt-1 res-991-mt-10 res-991-mb-1 text-center" />
                <div className="widget_nav_menu">
                  <div className="textwidget-widget-text">
                    <div className="prt-numbertext">
                      <div className="row">
                        <div className="col-xl-4 col-lg-6 col-md-6"></div>
                        <div className="col-xl-4 col-lg-6 col-md-6">
                          <p className="prt-numbertext-p">
                            Copyright © 2025{" "}
                            <a href="#" className="prt-numbertext-p-link">
                              Moironix Soft Solutions
                            </a>
                          </p>
                        </div>
                        <div className="col-xl-4 col-lg-6 col-md-6 text-end"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
